import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPlusSmall = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.75 7.32092H15V8.82092H8.75V15.0709H7.25V8.82092H1V7.32092H7.25V1.07092H8.75V7.32092Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPlusSmall);
const Memo = memo(ForwardRef);
export default Memo;
